import {
  Grid,
  Paper,
  MenuItem,
  Container,
  InputBase,
  Tooltip,
  TableHead,
  Link,
  Chip,
  Stack,
  Menu,
  List,
  Checkbox,
  FormControlLabel,
  Box,
  TableSortLabel,
} from '@mui/material'
import * as React from 'react'
import { createRef, useState } from 'react'
import SkeletonTableLoader from '../../../../common/components/loaders/skeletonLoader'
import IconButton from '@mui/material/IconButton'
import LoadingSection from '../../../../common/components/loaders/loader'
import { useLocation, useSearchParams } from 'react-router-dom'
import moment from 'moment/moment'
import {
  masterNotificationReceipientsByIdApi,
  masterNotificationTemplateCancelApi,
} from '../../../../api/master/masterAPI'
import ConformationModal from '../../../../common/components/custom/modal/modal'
import SearchIcon from '@mui/icons-material/Search'
import VisibilityIcon from '@mui/icons-material/Visibility'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import NoDataFoundCard from '../../../../common/components/cards/noDataFoundCard'
import TablePagination from '@mui/material/TablePagination'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import DetailsModal from '../../../../common/components/custom/modal/detailsModal'
import ListItemIcon from '@mui/material/ListItemIcon'
import MailIcon from '@mui/icons-material/Mail'
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo'
import {
  ExportExcel,
  getNotificationName,
  getContactTypeName,
  getCompanyLevelName,
  checkPermission,
  normalizeApiResponse,
  getComparator,
  stableSort,
} from '../../../../helpers/HelperFunctions'
import { PERMISSIONS } from '../../../../helpers/Constants'
import { useToastContext } from '../../../../App'
import { useCommonRedux } from '../../../../store/middlewares/CommonRedux'
import ColumnFilter from '../../../../common/components/tableFilter/ColumnFilter'
import FilterListIcon from '@mui/icons-material/FilterList';
import useTableFilters from '../../../../common/components/tableFilter/useTableFilters'
import GlobalSearch from '../../../../common/components/tableFilter/GlobalSearch'

// ──────────────────────────────────────────────────────────────
// Table Column configuration
// ──────────────────────────────────────────────────────────────
const tableColumns = [
  {
    key: 'statusLabel',
    label: 'Status',
    getValue: (row) => row.statusLabel,
    getLabel: (row) =>
      typeof row.statusLabel === 'string'
        ? row.statusLabel
        : getNotificationName(row.status)?.props?.children?.[0] || '',
  },
  {
    key: 'dateTime',
    label: 'Date & Time Sent',
    getValue: (row) => row.dateTime,
    getLabel: (row) => row.dateTime || '',
  },
  {
    key: 'method',
    label: 'Method',
    getValue: (row) => row.method,
    getLabel: (row) => row.method || '',
  },
  {
    key: 'subject',
    label: 'Subject',
    getValue: (row) => row.subject,
    getLabel: (row) => row.subject || '',
  },
]
export function NotificationList(props) {
  const { dispatch, state: commonState } = useCommonRedux()
  const { toast } = useToastContext()
  const [showEdit, setShowEdit] = React.useState(false)
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(5)
  const [recipientsList, setRecipientsList] = React.useState()
  const [exportRecipients, setExportRecipients] = React.useState([])
  const [edited, setEdited] = React.useState('')
  const [userDetails, setUserDetails] = React.useState('')
  const [state, setState] = React.useState({
    right: false,
  })
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDetails, setIsOpenDetails] = useState(false)
  const [resetPageOpen, setResetPageOpen] = useState(false)
  const [submitLoader, setSubmitLoader] = React.useState(false)
  const [touched, setTouched] = React.useState(true)
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const [rowData, setRowData] = React.useState(null)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const pageTopRef = createRef()
  const open = Boolean(anchorEl)
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState()
  const [loader, setLoader] = React.useState(false)
   const renderDateTime = (row) => {
    if (row.sentDateTime && row.status == 3)
      return moment(row.sentDateTime).format('YYYY MMM, DD - hh:mm a')
    if (row.scheduledDateTime && row.status == 2)
      return moment(row.scheduledDateTime).format('YYYY MMM, DD - hh:mm a')
    return ''
  }
  const mappedRows = (props?.rowsList || []).map((row) => ({
    ...row,
    statusLabel: getNotificationName(row.status),
    dateTime: renderDateTime(row),
    method: `${row.isApp ? 'In App ' : ''}${row.isEmail ? 'Email' : ''}`.trim(),
  }))
  

  const {
    searchTerm,
    setSearchTerm,
    filteredData,
    uniqueValues,
    filterAnchorEl,
    setFilterAnchorEl,
    currentColumn,
    openFilter,
    closeFilter,
    toggleFilter,
    clearColumnFilter,
    isFilterActive,
    filters,
  } = useTableFilters(mappedRows, tableColumns);
  const currentLabel = tableColumns.find((c) => c.key === currentColumn)?.label || currentColumn || '';
  const sortedRows = React.useMemo(() => {
    return stableSort(filteredData, getComparator(order, orderBy));
  }, [filteredData, order, orderBy]);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }
  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget)
    setRowData(row)
  }
  const handleClose = () => {
    setAnchorEl(null)
    setIsOpen(false)
    setIsOpenDetails(false)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    pageTopRef.current.scrollTop = 0
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number(event.target.value))
    setPage(0)
    pageTopRef.current.scrollTop = 0
  }
  let inputHandler = (e) => {
    const lowerCase = e.target.value.toLowerCase()
    const filteredData = props.rowsListFiltered.filter((el) => {
      if (lowerCase === '') {
        return el
      } else {
        return el?.subject.toLowerCase().includes(lowerCase)
      }
    })
    props.setRowsList(filteredData)
  }
  const handleNotificationById = (row, i) => {
    if (row) {
      props.setDetailsData(row)
      props?.setHideEdit(true)
    }
  }

  const handleReceptionsDetails = () => {
    if (rowData) {
      setSubmitLoader(true)
      masterNotificationReceipientsByIdApi(rowData.id)
        .then((response) => {
          setSubmitLoader(false)

          setRecipientsList(response.data.result)
          let exportMapData = response.data.result?.recipients.map(
            (dat, ind) => {
              return {
                'S.No.': ind + 1,
                'User Account': dat.email,
                'Company Name': dat.companyName,
                Level: getCompanyLevelName(dat.companyLevel),
                Contact: getContactTypeName(dat.contactType),
                Type: dat.isEmail ? 'Email' : 'In App',
                // 'Read Status': dat.isViewed ? 'Yes' : dat.isEmail ? '-' : 'No',
              }
            }
          )
          setExportRecipients(exportMapData)
          setShowEdit(false)
          setIsOpenDetails(true)
        })
        .catch((error) => {
          setSubmitLoader(false)
          toast.showToast(normalizeApiResponse(error)?.message, 'error')
        })
    }
  }

  const handleNotificationConformation = () => {
    setIsOpen(true)
  }
  const handleNotificationDelete = () => {
    if (rowData) {
      setSubmitLoader(true)
      masterNotificationTemplateCancelApi(rowData.id)
        .then((response) => {
          setSubmitLoader(false)
          props.getDecodeValue()
          toast.showToast(response?.data?.message, 'success')
          setRowData(null)
          handleClose()
        })
        .catch((error) => {
          setSubmitLoader(false)
          toast.showToast(normalizeApiResponse(error)?.message, 'error')
        })
    }
  }

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - filteredData.length)
      : 0

 

  const renderMethodChips = (row) => (
    <Stack direction="row" spacing={1}>
      {row.isApp && <Chip label="In App" variant="outlined" />}
      {row.isEmail && <Chip label="Email" variant="outlined" />}
    </Stack>
  )

  const renderRecipients = (row) => (
    <Grid container columnSpacing={1} rowSpacing={1}>
      <Grid item xs={5}>
        <Stack direction="column" spacing={1}>
          {row.companyLevel.map((mapDat) => (
            <Chip
              key={mapDat}
              label={getCompanyLevelName(mapDat.companyLevel)}
              variant="outlined"
            />
          ))}
        </Stack>
      </Grid>
      <Grid item xs={5}>
        <Stack direction="column" spacing={1}>
          {row.contactType.map((mapDat) => (
            <Chip key={mapDat} label={getContactTypeName(mapDat.contactType)} />
          ))}
        </Stack>
      </Grid>
    </Grid>
  )

  const renderActionMenu = (row) => {
    const canDelete =
      checkPermission(
        [PERMISSIONS.masterNotificationDelete],
        commonState.currentCompanyDetails
      ) &&
      (rowData?.status == 2 || rowData?.status == 1) &&
      !rowData?.isCancel

    return (
      <>
        {((row?.status == 3 ||
          ((row?.status == 2 || row?.status == 1) && !row?.isCancel))) && (
            <MoreVertIcon
              id="basic-button"
              onClick={(e) => handleClick(e, row)}
              style={{ width: '32px', height: '32px', cursor: 'pointer' }}
            />
          )}
        <Menu anchorEl={anchorEl} open={open} elevation={1} onClose={handleClose}>
          {rowData?.status == 3 && (
            <MenuItem onClick={handleReceptionsDetails}>
              <Tooltip title="View Recipients">
                <>
                  <VisibilityIcon color="primary" /> View Recipients
                </>
              </Tooltip>
            </MenuItem>
          )}

          {canDelete && (
            <MenuItem onClick={handleNotificationConformation}>
              <Tooltip
                title={
                  rowData?.status == 1
                    ? 'Delete Notification'
                    : 'Cancel Notification'
                }
              >
                <>
                  <CancelPresentationIcon color="primary" />
                  {rowData?.status == 1
                    ? 'Delete Notification'
                    : 'Cancel Notification'}
                </>
              </Tooltip>
            </MenuItem>
          )}
        </Menu>
      </>
    )
  }

  const renderTableRows = () =>
    // (props?.rowsList || [])
    //   .slice(
    //     rowsPerPage > 0 ? page * rowsPerPage : 0,
    //     rowsPerPage > 0 ? page * rowsPerPage + rowsPerPage : undefined
    //   )
    (rowsPerPage > 0
      ? filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      )
      : filteredData
    ).map((row, index) => (
      <TableRow hover key={index}>
        <TableCell width={'10px'}>{page * rowsPerPage + index + 1}</TableCell>
        <TableCell scope="row">
          <Link onClick={() => handleNotificationById(row, index)}>
            {getNotificationName(row.status)}
          </Link>
        </TableCell>
        <TableCell>{renderDateTime(row)}</TableCell>
        <TableCell>{renderMethodChips(row)}</TableCell>
        <TableCell>{row.subject}</TableCell>
        <TableCell>{renderRecipients(row)}</TableCell>
        <TableCell>{renderActionMenu(row)}</TableCell>
      </TableRow>
    ))

  const RecipientDetailsTable = ({ recipientsList }) => {
    const emptyRows = 5 // or however you define it in your parent

    return (
      <List sx={{ width: '100%', mt: '-20px', bgcolor: 'background.paper' }}>
        <Tooltip title="Mail Notification">
          <FormControlLabel
            sx={{ marginLeft: '8px' }}
            control={<Checkbox checked={recipientsList?.isEmail} disabled />}
            label={
              <ListItemIcon sx={{ mt: '8px' }}>
                <MailIcon /> Mail
              </ListItemIcon>
            }
          />
        </Tooltip>

        <Tooltip title="App Notification">
          <FormControlLabel
            sx={{ marginLeft: '8px' }}
            control={<Checkbox checked={recipientsList?.isApp} disabled />}
            label={
              <ListItemIcon sx={{ mt: '8px' }}>
                <PersonalVideoIcon /> In App
              </ListItemIcon>
            }
          />
        </Tooltip>

        <TableContainer sx={{ height: 380 }} component={Paper}>
          <Table stickyHeader sx={{ minWidth: 400 }} aria-label="custom pagination table">
            <TableHead className="thead">
              <TableRow>
                <TableCell>User Account</TableCell>
                <TableCell>Company Name</TableCell>
                <TableCell>Level</TableCell>
                <TableCell>Contact</TableCell>
                <TableCell>Type</TableCell>
              </TableRow>
            </TableHead>

            <TableBody className="tbody">
              {recipientsList?.recipients?.map((mapDat, index) => (
                <TableRow hover key={index}>
                  <TableCell scope="row">{mapDat?.email}</TableCell>
                  <TableCell scope="row">{mapDat?.companyName}</TableCell>
                  <TableCell scope="row">{getCompanyLevelName(mapDat?.companyLevel)}</TableCell>
                  <TableCell scope="row">{getContactTypeName(mapDat?.contactType)}</TableCell>
                  <TableCell>
                    {mapDat?.isEmail ? (
                      <Tooltip title="Mail Notification">
                        <ListItemIcon sx={{ mr: '20px' }}>
                          <MailIcon />
                          <span style={{ width: '70px' }}>Mail</span>
                        </ListItemIcon>
                      </Tooltip>
                    ) : (
                      <Tooltip title="App Notification">
                        <ListItemIcon sx={{ mr: '20px' }}>
                          <PersonalVideoIcon />
                          <span style={{ width: '70px' }}>In App</span>
                        </ListItemIcon>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}

              {recipientsList?.recipients?.length > 0 && (
                <TableRow style={{ height: 30 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}

              {recipientsList?.recipients?.length === 0 && (
                <TableRow style={{ height: 30 * emptyRows }}>
                  <TableCell colSpan={6} style={{ border: 'none' }}>
                    <h3
                      style={{
                        margin: '0px auto',
                        padding: '20px 0',
                        textAlign: 'center',
                      }}
                    >
                      <NoDataFoundCard
                        messages="No Notification found"
                        borderNone={true}
                      />
                    </h3>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </List>
    )
  }

  // --- main render ---
  return (
    <>
      {submitLoader && <LoadingSection />}
      <Container maxWidth="xl">
        {submitLoader && <LoadingSection />}

        {/* 🔍 Search */}
        <GlobalSearch
          sx={{ marginBottom: '8px' }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
          placeholder="Search Notifications"
        />

        {/* 📋 Main Table */}
        <TableContainer sx={{ height: 450 }} component={Paper} ref={pageTopRef}>
          <Table stickyHeader sx={{ minWidth: 500 }} aria-label="custom pagination table">
            <TableHead className="thead">
              <TableRow>
                <TableCell>S.No</TableCell>
                {tableColumns.map((col) => (
                  <TableCell key={col.key}>
                    <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <TableSortLabel
                        active={orderBy === col.key}
                        direction={orderBy === col.key ? order : 'asc'}
                      // onClick={(e) => handleRequestSort(e, col.key)}
                      >{col.label}</TableSortLabel>
                      <IconButton
                        size="small"
                        onClick={(e) => openFilter(e, col.key)}
                        color={isFilterActive(col.key) ? 'primary' : 'default'}
                      >
                        <FilterListIcon fontSize="small" />
                      </IconButton>
                      {isFilterActive(col.key) && (
                        <Chip size="small"
                          label={(filters?.[col.key]?.length || 0)}
                          //  label={filters[col.key]?.length  || 0} 
                          color="primary" />
                      )}
                    </Box>
                  </TableCell>
                ))}
                {/* <TableCell>Status</TableCell>
                <TableCell>Date & Time Sent</TableCell>
                <TableCell>Method</TableCell>
                <TableCell>Subject</TableCell>
                <TableCell>Recipients</TableCell> */}
                <TableCell></TableCell>
              </TableRow>
            </TableHead>

            {props?.loader ? (
              <TableBody>
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6}>
                    <SkeletonTableLoader />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody className="tbody">
                {renderTableRows()}

                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
                {filteredData.length === 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} style={{ border: 'none' }}>
                      <h3
                        style={{
                          margin: '0px auto',
                          textAlign: 'center',
                        }}
                      >
                        <NoDataFoundCard
                          messages="No Notification Created"
                          borderNone
                        />
                      </h3>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Stack direction="row" justifyContent="space-between">
          {!loader && (
            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-start', px: 2 }}>
              <Chip
                label={
                  <>
                    <strong>{filteredData.length}</strong> / {props.rowsList.length} records
                  </>
                }
                color={filteredData.length < props.rowsList.length ? 'primary' : 'default'}
                variant="outlined"
                size="small"
              />
              {(filters && Object.keys(filters).length > 0 || searchTerm.trim()) && (
                <Chip
                  label="Filtered"
                  color="secondary"
                  size="small"
                  sx={{ ml: 1 }}
                />
              )}
            </Box>
          )}
          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
            component="div"
            count={filteredData?.length}
            // count={props?.rowsList?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Stack>
        <ColumnFilter
          anchorEl={filterAnchorEl}
          onClose={closeFilter}
          columnLabel={currentLabel}
          uniqueValues={uniqueValues[currentColumn] || []}
          selectedValues={filters ? filters[currentColumn] : []}
          onToggleValue={toggleFilter}
          onClear={clearColumnFilter}
        />
        {/* Modals */}
        <ConformationModal
          handleConfirm={handleNotificationDelete}
          title="Confirmation"
          content={`Are you sure want to ${rowData?.status == 1 ? 'delete' : 'cancel'
            } notification?`}
          isOpen={isOpen}
          handleClose={handleClose}
        />
        <DetailsModal
          maxWidth="lg"
          title={
            <div>
              Recipients Details
              <ExportExcel
                fileName={`${rowData?.subject}_${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`}
                excelData={exportRecipients}
              />
            </div>
          }
          content={<RecipientDetailsTable recipientsList={recipientsList} />}
          isOpen={isOpenDetails}
          handleClose={handleClose}
        />
      </Container>
    </>
  )
}

export default NotificationList
